import { Backdrop, Button, Stack, Typography } from "@mui/material"
import MainCard from "../main-card"
import { useState } from "react"
import { CloseCircle } from "iconsax-react"
import Image from "next/image"
import BasicLogo from "../BasicLogo"

// -------------------------------------------------|| MODAL CLUB - COMPONENTS ||-------------------------------------------------
export function toPersian(v) {
  return Number(v).toLocaleString()
}

const ModalClub = ({ open, price, plan }) => {
  const [openModal, setOpenModal] = useState(open)
  const handleClose = () => {
    setOpenModal(false)
  }
  return (
    <Backdrop open={openModal} sx={{ zIndex: 1000000 }} fullWidth={true}>
      <MainCard shadow={3} sx={{ px: 6, py: 3, borderRadius: "18px", zIndex: 10000000, cursor: "pointer" }}>
        <CloseCircle color='grey' size={32} onClick={handleClose} />
        <Stack sx={{ display: "flex", alignItems: "center" }}>
          <BasicLogo  />
        </Stack>
        <Stack spacing={3} sx={{ display: "flex", alignItems: "right", mt: 1 }}>
          <Typography textAlign='center' color='primary' variant='h4' fontWeight='bold'>
            اشتراک {plan} جت وام
          </Typography>
          <Typography variant='subtitle2' fontSize={13}>
            عضویت طرح {plan} تنها برای متقاضیان دریافت تسهیلات
            {toPersian(price)} ریال قابل خرید می باشد.
          </Typography>
          <Typography variant='subtitle2' fontSize={13}>
            خواهشمند است ابتدا درخواست وام خود را ثبت یا تکمیل فرمایید.
          </Typography>
          <Button
            color='primary'
            variant='contained'
            size='medium'
            sx={{ borderRadius: "8px", width: "100%" }}
            onClick={handleClose}
          >
            متوجه شدم
          </Button>
        </Stack>
      </MainCard>
    </Backdrop>
  )
}
export default ModalClub
